import { render, staticRenderFns } from "./eduClassInfoView.vue?vue&type=template&id=12d8db98&"
import script from "./eduClassInfoView.vue?vue&type=script&lang=js&"
export * from "./eduClassInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports